import { z } from "zod";

export const bulkUpdateStockSchema = z.object({
  updates: z
    .array(z.object({ variantId: z.string().min(1), stock: z.number().int().min(0) }))
    .min(1)
    .max(500)
});
export type BulkUpdateStockInput = z.infer<typeof bulkUpdateStockSchema>;
